import { useContext, useState } from "react";

import TalentPoolEngineersListingHeader from "./TalentPoolEngineersListingHeader";

import BaseLoader from "../../components/ui/BaseLoader";

import { LayoutContext } from "../../context/LayoutContext";
import TalentPoolEngineersTable from "./TalentPoolEngineersTable";

const TalentPoolEngineers = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const [currentTalentPool, setCurrentTalentPool] = useState({});

  return (
    <>
      <BaseLoader isLoading={false} />
      <div
        className={`bg-[#F6F6F6] sm:fixed sticky 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all pt-4 ${
          isBannerVisible ? "top-[104px] sm:mt-0 mt-12" : "top-[42px]"
        }`}
      >
        <TalentPoolEngineersListingHeader
          currentTalentPool={currentTalentPool}
        />
        <TalentPoolEngineersTable setCurrentTalentPool={setCurrentTalentPool} />
      </div>
    </>
  );
};

export default TalentPoolEngineers;
